import * as zod from "zod";

import { ApiKeyFields } from "types";

export const schema = zod.object({
  [ApiKeyFields.value]: zod.union([zod.string(), zod.number()]),
});
